import css from 'styled-jsx/css';
import { colors, typography } from '../../config/styles';

export const Styles = css`
  .installments-text {
    margin: 0px;
    align-items: center;
    line-height: 16px;
    text-indent: -25px;
    padding-left: 25px;

    span {
      color: ${colors.gray.shade64};
      font-size: ${typography.sm};
      line-height: 16px;
      font-weight: 400;
      font-family: Lato, sans-serif;
    }
  }
  .cmr-icon {
    background-image: url('/a/fa/product/static/styles/svg/cmr_icon.svg');
    height: 13px;
    width: 20px;
    display: inline-block;
    margin-bottom: -3px;
  }
  .cmr-points {
    font-size: ${typography.sm};
    line-height: 16px;
    color: ${colors.gray.shade52};
  }
  .cmr-text {
    text-decoration: underline;
    text-underline-offset: 2px;
  }
  .cmr-info-container {
    @mixin tabletToDesktop {
      margin-top: 8px;
    }
    @mixin mobileToTablet {
      margin-bottom: 8px;
    }
  }
`;
